import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../quotation/ViewQuotation.scss";
import { GetOne } from "../../providers/dataProvider";
import { FormatValueDecimal,CurrencyConvertion } from "../../utils/Validate";

const ViewQuotation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [quotationDt, setQuotationDt] = useState(null);
  const [viewItem, setViewItem] = useState(null);
  const [currencyData, setCurrencyData] = useState([]);
  const [currencyDetail, setCurrencyDetail] = useState([]);
  const [quoteGeneral, setQuoteGeneral] = useState(null);
  const [percentageValue, setPercentageValue] = useState({customDutyValue:0,clearnceValue:0,taxValue:0})
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  
  useEffect(() => {
    if (location?.state?.item?.id) {
      const item = location?.state?.item;
      setCurrencyData(location?.state?.currencyList)
      setQuoteGeneral(location?.state?.quotegeneral)
      GetOne("quotation", { id: item?.id }, setQuotationDt);
    } else {
      navigate("/quotation-general");
    }
  }, [location?.state]);

  useEffect(() => {
    if (quotationDt?.message === "success")
      setViewItem(quotationDt?.data);
  }, [quotationDt]);

  const navigateToQuotationGeneral = () => {
    navigate("/quotation-general", {
      state: {
        row: quoteGeneral?.row,
        id: quoteGeneral?.id,
      },
    });
  };

  useEffect(()=>{
   let customDutyValue = (((viewItem?.totalExworksPrice * 1) + (viewItem?.freightCharges * 1)) * ((viewItem?.customDutyPercentage * 1) / 100))
   let clearnceValue = (((viewItem?.totalExworksPrice * 1) + (viewItem?.freightCharges * 1) + (customDutyValue * 1)) * ((viewItem?.clearanceChargesPercentage * 1) / 100))
   const salesMarginValue = ((viewItem?.totalLandedCost * 1) / (1 - (viewItem?.salesMarginPercentage / 100)))
   let taxValue = ((salesMarginValue * 1) * ((viewItem?.taxPercentage * 1) / 100))

   setPercentageValue({
    customDutyValue:customDutyValue,
    clearnceValue:clearnceValue,
    taxValue:taxValue
   })
  },[viewItem])

  useEffect(()=>{
    setCurrencyDetail(currencyData?.find(item => item?.id === viewItem?.currencyId))
  },[currencyData,viewItem?.currencyId])

  return (
    <div className="container-fluid view-quotation-sec pl-5 pr-5">
      <section className="quotation-view-sec mt-3">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card">
              <div className="card-header pl-3">
                <div class="d-flex align-items-center">
                  <h1>
                    <i class="fas fa-angle-left mr-2" onClick={navigateToQuotationGeneral}></i>
                    {viewItem?.quoteReference} Summary
                  </h1>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div style={{ display: "none" }} className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Total list price</h5>
                      <h6>{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(viewItem?.totalListPrice,viewItem?.conversionRate,currencyDetail))}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Net price</h5>
                      <h6>{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(viewItem?.netPrice,viewItem?.conversionRate,currencyDetail))}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Special color</h5>
                      <h6>{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(viewItem?.specialCharges,viewItem?.conversionRate,currencyDetail))}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Total Ex-Works price</h5>
                      <h6>{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(viewItem?.totalExworksPrice,viewItem?.conversionRate,currencyDetail))}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Frieght & delivery charges</h5>
                      <h6>{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(viewItem?.freightCharges,viewItem?.conversionRate,currencyDetail))}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Custom Duty</h5>
                      <h6>{currencyDetail?.shortCode} {viewItem?.customDuty > 0 ? FormatValueDecimal(CurrencyConvertion(viewItem?.customDuty,viewItem?.conversionRate,currencyDetail)) : FormatValueDecimal(CurrencyConvertion(percentageValue?.customDutyValue,viewItem?.conversionRate,currencyDetail))}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Clearance charges</h5>
                      <h6>{currencyDetail?.shortCode} {viewItem?.clearanceCharges > 0 ? FormatValueDecimal(CurrencyConvertion(viewItem?.clearanceCharges,viewItem?.conversionRate,currencyDetail)): FormatValueDecimal(CurrencyConvertion(percentageValue?.clearnceValue,viewItem?.conversionRate,currencyDetail))}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Total Landed Cost</h5>
                      <h6>{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(viewItem?.totalLandedCost,viewItem?.conversionRate,currencyDetail))}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Sales Margin (%)</h5>
                      <h6>{viewItem?.salesMarginPercentage}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Total Selling Price</h5>
                      <h6>{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(viewItem?.totalSellingPrice,viewItem?.conversionRate,currencyDetail))}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Tax</h5>
                      <h6>{currencyDetail?.shortCode} {viewItem?.tax > 0 ? FormatValueDecimal(CurrencyConvertion(viewItem?.tax,viewItem?.conversionRate,currencyDetail)) : FormatValueDecimal(CurrencyConvertion(percentageValue?.taxValue,viewItem?.conversionRate,currencyDetail)) }</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Grand Total</h5>
                      <h6>{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(viewItem?.grandTotal,viewItem?.conversionRate,currencyDetail))}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header pl-3">
                <h1>Product List</h1>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-4">
                    <div className="table-sec">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th className="text-left">Product Group</th>
                            <th>Model Number</th>
                            <th style={{ textAlign: "right" }}>Quantity</th>
                            {userProfile?.specialPermissions?.indexOf(2) > -1 && <th style={{ textAlign: "right", display: "none" }}>List Price</th>}
                            {userProfile?.specialPermissions?.indexOf(2) > -1 && <th style={{ textAlign: "right" }}>Discount</th>}
                            <th style={{ textAlign: "right" }}>Net Price</th>
                            <th style={{ textAlign: "right", display:"none" }}>Sales Margin(%)</th>
                            <th style={{ textAlign: "right", display:"none" }}>Selling Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            viewItem?.products?.map((item, index) => {
                              const discount = (item?.listPrice * (item?.discount / 100))
                              return (
                                <tr>
                                  <td className="text-left">
                                    {item?.groupName}
                                  </td>
                                  <td>{item?.productName}</td>
                                  <td style={{ textAlign: "right" }}>{item?.quantity}</td>
                                  {userProfile?.specialPermissions?.indexOf(2) > -1 &&  <td style={{ textAlign: "right", display: "none" }}>{FormatValueDecimal(CurrencyConvertion(item?.listPrice,viewItem?.conversionRate,currencyDetail))}</td>}
                                  {userProfile?.specialPermissions?.indexOf(2) > -1 && <td style={{ textAlign: "right" }}>{item?.discount}</td>}
                                  <td style={{ textAlign: "right" }}>{FormatValueDecimal(CurrencyConvertion(item?.listPrice * 1 - discount,viewItem?.conversionRate,currencyDetail))}</td>
                                  <td style={{ textAlign: "right", display:"none" }}>{item?.salesMargin}</td>
                                  <td style={{ textAlign: "right", display:"none" }}>{FormatValueDecimal(CurrencyConvertion(item?.sellingPrice,viewItem?.conversionRate,currencyDetail))}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewQuotation;
